import { ReactNode, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import { PrivatePage } from '@hcs/authn';
import { useAppAccessCheck } from '@hcs/authz';
import { SOLUTIONS_URL } from '@hcs/urls';
import { createRedirectQuerystring } from '@hcs/utils';

import { VIEW_PATHS_ACCESS_OM_DEMO } from '../apps/access';

// Internal component for checking that the org is the right type
// When this mounts, the user is already confirmed to be logged in
const HasAgileSuiteAccess = ({ children }: { children: ReactNode }) => {
  const { isFetched, data: hasAccess } = useAppAccessCheck('agile-suite');
  useEffect(() => {
    if (isFetched && !hasAccess) {
      window.location.href = SOLUTIONS_URL;
    }
  }, [isFetched, hasAccess]);

  if (hasAccess) {
    return children;
  }
  return null;
};
// Creates a page component that is accessible to anyone with a valid token
// Attempts to refresh accessToken if it is invalid and will redirect to login
// If token is invalid
export const OmDemoPageRedirect = ({
  children,
  noRedirectQuery,
}: {
  children: ReactNode;
  noRedirectQuery?: boolean;
}) => {
  const redirectQuery = noRedirectQuery ? '' : createRedirectQuerystring();
  return (
    <PrivatePage
      unauthenticatedRender={
        <Navigate
          to={`${VIEW_PATHS_ACCESS_OM_DEMO.LOGIN}${redirectQuery}`}
          replace
        />
      }
    >
      <HasAgileSuiteAccess>{children}</HasAgileSuiteAccess>
    </PrivatePage>
  );
};
